/**
 * Formats a date string or Date object to "DD-Mon-YY" format
 * Examples: "25-Mar-26", "01-Jan-25", "15-Dec-24"
 * 
 * @param {string|Date} dateInput - Date string (YYYY-MM-DD, ISO, etc.) or Date object
 * @returns {string} Formatted date string like "25-Mar-26"
 */
export const formatDateDDMonYY = (dateInput) => {
  if (!dateInput) return '-';
  try {
    let d;
    if (dateInput instanceof Date) {
      d = dateInput;
    } else {
      const str = String(dateInput);
      // Handle YYYY-MM-DD without timezone shift
      if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        const [y, m, day] = str.split('-').map(Number);
        d = new Date(y, m - 1, day);
      } else {
        d = new Date(str);
      }
    }
    if (isNaN(d.getTime())) return String(dateInput);
    const day = String(d.getDate()).padStart(2, '0');
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const mon = months[d.getMonth()];
    const yr = String(d.getFullYear()).slice(-2);
    return `${day}-${mon}-${yr}`;
  } catch {
    return String(dateInput);
  }
};
